import { INewsDetailReponse } from "../../../model/base/response/news-detail-response";

export enum ACTION_TYPES {
    SET_NEWS_DETAIL = 'SET_NEWS_DETAIL'
}

export interface INewsDetailState {
    newsDetail: INewsDetailReponse | null;
}

export const initialState: INewsDetailState = {
    newsDetail: null
};

export type Action =
    | { type: ACTION_TYPES.SET_NEWS_DETAIL; payload: INewsDetailReponse };

export const newsDetailReducer = (state: INewsDetailState, action: Action): INewsDetailState => {
    switch (action.type) {
        case ACTION_TYPES.SET_NEWS_DETAIL:
            return { ...state, newsDetail: action.payload };
        default:
            throw new Error(`Unhandled action type`);
    }
};
